import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap} from '@angular/router';
import {Principal} from 'src/app/core';
import {ILoadingTypeDto} from 'src/app/shared/model/loading-type-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {RoleUtil} from 'src/app/shared/util/role-util';

@Component({
    selector: 'jhi-loading-type-my-suffix-detail',
    templateUrl: './loading-type-my-suffix-detail.component.html'
})
export class LoadingTypeMySuffixDetailComponent implements OnInit {
    loadingType: ILoadingTypeDto;
    isShowPastHistory: any;
    isShowFutureHistory: any;

    public readonly RoleUtil = RoleUtil;

    constructor(private principal: Principal,
         private activatedRoute: ActivatedRoute,
          private languageChangeService: LanguageChangeService
          ) {
            this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
    });
           }

    ngOnInit() {
        this.isShowPastHistory = this.principal.isShowPastHistory;
        this.isShowFutureHistory = this.principal.isShowFutureHistory;
        this.activatedRoute.data.subscribe(({ loadingType }) => {
            this.loadingType = loadingType;
        });
    }

    previousState() {
        window.history.back();
    }

    // history
    historyData = [];
    historyTitle: string;
    historyType: string;
    historyId: number;
    
    parentHistoryToggle = false;
    parentFutureHistoryToggle = false;
    receiveToggleEvent($event) {
        this.parentHistoryToggle = $event;
        this.parentFutureHistoryToggle = $event;
    }

    viewFutureHistory(Obj) {
        this.parentFutureHistoryToggle = true;
        this.historyTitle = 'Loading Type (' + Obj.name + ') Future Records';
        this.historyType = "LOADING_TYPE_AUDIT";
        this.historyId = Obj.id;
    }

    viewHistory(Obj) {
        this.parentHistoryToggle = true;
        this.historyTitle = 'Loading Type (' + Obj.name + ') History';
        this.historyType = "LOADING_TYPE_AUDIT";
        this.historyId = Obj.id;
    }
    hideFutureHistorySidebar() {
        if (document.getElementById("future-history-window")) {
            this.parentHistoryToggle = false;
            this.parentFutureHistoryToggle = false;
        }
    }
}
